import React from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
// Formik validation
// import BottomFooter from "../../components/BottomFooter";
import { useConfirmUserEmail } from "../../hooks/useAuth";
import { AlertComponent, AlertSuccessComponent } from "./AlertComponent";

function ConfirmEmail() {
  const navigate = useNavigate();
  const [errorArray, setErrorArray] = React.useState([]);
  const [isLoading, setIsloading] = React.useState(false);
  const [searchParams] = useSearchParams();

  let userId = searchParams.get("userId") ?? "";
  let token = searchParams.get("token") ?? "";

  const { isPending, isError, error, isSuccess } = useConfirmUserEmail({
    userId,
    token,
  });

  const handlelogin = () => {
    setIsloading(true);
    setTimeout(() => {
      navigate("/auth/login?message=Email confirmed successfully", {
        replace: true,
      });
    }, 3000);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  React.useEffect(() => {
    const errs = [];

    if (isError) errs.push(`confirm user: ${error}`);

    setErrorArray(errs);
  }, [isError, error]);

  if (!userId || !token) {
    return <Navigate to={"/auth/login"} replace state={null} />;
  }

  return (
    <React.Fragment>
      <div className="auth-page-content mt-lg-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4 col-lg-4 col-xl-4">
              {isSuccess && (
                <AlertSuccessComponent
                  message={"Email confirmed successfully"}
                />
              )}
              {isError && <AlertComponent errorArray={errorArray} />}
              <div className="card mt-24 shadow-lg border-0">
                <div className="card-body text-center p-24">
                  <div className="text-center mt-2">
                    <h6 className="text-dark mb-1">Confirm Email!</h6>
                    <p className="text-muted">
                      validate email to continue to phAMACart.
                    </p>
                  </div>
                  <div className="p-2 mt-24">
                    {isPending && (
                      <>
                        <div className="container p-20">
                          <div className="text-center">
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {!isPending && (
                      <>
                        {isSuccess ? (
                          <>
                            <div className="avatar-lg mx-auto mt-2">
                              <div className="avatar-title bg-light text-success display-3 rounded-circle">
                                <i className="ph-fill ph-check-circle"></i>
                              </div>
                            </div>
                            <div className="mt-4 pt-2">
                              <h4>Well done !</h4>
                              <p className="text-muted mx-4">
                                Aww yeah, you successfully read this important
                                message.
                              </p>
                              <div className="mt-4">
                                <button
                                  className="btn btn-success w-100"
                                  onClick={handlelogin}
                                  disabled={isLoading}
                                >
                                  {isLoading && (
                                    <div
                                      className="spinner-border spinner-border-sm me-5"
                                      role="status"
                                    ></div>
                                  )}
                                  Back to Login
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="avatar-lg mx-auto mt-2">
                              <div className="avatar-title bg-light text-danger display-3 rounded-circle">
                                <i className="ph-fill ph-warning"></i>
                              </div>
                            </div>
                            <div className="mt-4 pt-2">
                              <h5>Email confirmation Failed !</h5>
                              <p className="text-muted mx-4">
                                try to confirm again by refreshing
                              </p>
                              <div className="mt-4">
                                <button
                                  className="btn btn-success w-100"
                                  onClick={handleRefresh}
                                  disabled={isPending}
                                >
                                  Refresh
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-24 text-center">
                <p className="mb-0">
                  Already validated ?{" "}
                  <Link
                    className="fw-semibold text-primary text-decoration-underline"
                    to="/auth/login"
                    data-discover="true"
                  >
                    {" "}
                    Signin{" "}
                  </Link>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BottomFooter */}
      {/* <div id="footer">
        <BottomFooter />
      </div> */}
    </React.Fragment>
  );
}

export default ConfirmEmail;
